import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { ApiLink } from '../../../APILink/ApiLink';
import authHeader from '../../../Auth/authHeader';
import { errorAlert } from '../../../Components/Alerts';
import { FiscalYearContext } from '../../../FiscalYear/FiscalYearContext';
import './RecentTransactions.scss';

const ACTION_TYPE_META = {
  IND: { label: 'Shitje Detale',    tone: 'green'  },
  INT: { label: 'Shitje Total',     tone: 'green'  },
  INC: { label: 'Shitje',           tone: 'green'  },
  POT: { label: 'Blerje Total',     tone: 'blue'   },
  POD: { label: 'Blerje Detale',    tone: 'blue'   },
  PD:  { label: 'Blerje Detale',    tone: 'blue'   },
  PC:  { label: 'Blerje',           tone: 'blue'   },
  POF: { label: 'Blerje Fermeret',  tone: 'blue'   },
  IMP: { label: 'Import',           tone: 'amber'  },
  INP: { label: 'Blerje Investive', tone: 'amber'  },
  IMI: { label: 'Import Investiv',  tone: 'amber'  },
  EXP: { label: 'Shpenzime',        tone: 'red'    },
  EXB: { label: 'Shpenzim',         tone: 'red'    },
  SP:  { label: 'Shpenzime',        tone: 'red'    },
  INV: { label: 'Investim',         tone: 'amber'  },
  RENT:{ label: 'Qira',             tone: 'purple' },
};

const getActionMeta = (actionType) =>
  ACTION_TYPE_META[actionType] || { label: actionType || '—', tone: 'slate' };

const buildInvoiceNumber = (row) => {
  if (row.ActionType === 'IND') {
    return `${row.ActionType}-${row.FiscalYear}-${row.InvoiceNr}`;
  }
  return row.InvoiceNr || '—';
};

const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  return String(dateStr).substring(0, 10);
};

const formatMoney = (value) => {
  const num = Number(value);
  if (!num) return '€ 0.00';
  return `€ ${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const ROW_SKELETON_COUNT = 5;

function SkeletonRow() {
  return (
    <tr className="rt-table__row rt-table__row--skeleton">
      <td className="rt-table__cell"><span className="rt-skeleton rt-skeleton--badge" /></td>
      <td className="rt-table__cell"><span className="rt-skeleton rt-skeleton--md" /></td>
      <td className="rt-table__cell"><span className="rt-skeleton rt-skeleton--lg" /></td>
      <td className="rt-table__cell"><span className="rt-skeleton rt-skeleton--sm" /></td>
      <td className="rt-table__cell rt-table__cell--right"><span className="rt-skeleton rt-skeleton--md" /></td>
      <td className="rt-table__cell" style={{ display: 'none' }} />
    </tr>
  );
}

export default function RecentTransactions() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { fiscalYear } = useContext(FiscalYearContext);

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          ApiLink.API_URL + 'Dashboard/top5transactions',
          {
            headers: authHeader(),
            params: { fiscalYear },
          }
        );
        setData(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        errorAlert('Gabim në kërkesë:', error);
        if (error.response?.data?.errorMessage) {
          errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
        } else if (error.message) {
          errorAlert(`Gabim: ${error.message}`);
        } else {
          errorAlert('Gabim i panjohur në kërkesë. Shih konsolën për detaje.');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [fiscalYear]);

  return (
    <section className="rt-panel">
      <div className="rt-panel__header">
        <div>
          <h3 className="rt-panel__title">Transaksionet e Fundit</h3>
          <p className="rt-panel__subtitle">5 lëvizjet e fundit financiare nga viti fiskal aktiv</p>
        </div>

      </div>

      <div className="rt-table__wrapper">
        <table className="rt-table">
          <thead className="rt-table__head">
            <tr>
              <th className="rt-table__th">Tipi</th>
              <th className="rt-table__th">Nr. Faturës</th>
              <th className="rt-table__th">Emri Llogarisë</th>
              <th className="rt-table__th">Data</th>
              <th className="rt-table__th rt-table__th--right">Totali</th>
            </tr>
          </thead>
          <tbody>
            {loading
              ? Array.from({ length: ROW_SKELETON_COUNT }).map((_, i) => (
                  <SkeletonRow key={i} />
                ))
              : data.length === 0
              ? (
                <tr>
                  <td colSpan={5} className="rt-table__empty">
                    Nuk ka transaksione për vitin fiskal të zgjedhur.
                  </td>
                </tr>
              )
              : data.map((row) => {
                  const meta = getActionMeta(row.ActionType);
                  return (
                    <tr key={row.TransactionID} className="rt-table__row">
                      <td className="rt-table__cell">
                        <span className={`rt-badge rt-badge--${meta.tone}`}>{meta.label}</span>
                      </td>
                      <td className="rt-table__cell rt-table__cell--mono">
                        {buildInvoiceNumber(row)}
                      </td>
                      <td className="rt-table__cell rt-table__cell--account">
                        {row.AccountName || '—'}
                      </td>
                      <td className="rt-table__cell rt-table__cell--date">
                        {formatDate(row.Date)}
                      </td>
                      <td className="rt-table__cell rt-table__cell--right rt-table__cell--amount">
                        {formatMoney(row.Total)}
                      </td>
                    </tr>
                  );
                })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
